import React from 'react';
import { styled } from '@mui/material/styles';

import { hexToRgb } from '../../../services/styleUtils/colorUtils.js';

interface KitCardBodyProps {
  className?: string;
  children?: React.ReactNode;
  background?: boolean;
  plain?: boolean;
  formHorizontal?: boolean;
  pricing?: boolean;
  signup?: boolean;
  hasColor?: boolean;
  [key: string]: unknown;
}

interface KitCardBodyStyleProps {
  background?: boolean;
  plain?: boolean;
  formHorizontal?: boolean;
  pricing?: boolean;
  signup?: boolean;
  hasColor?: boolean;
}

export default function CardBody({
  className,
  children,
  background = false,
  plain = false,
  formHorizontal = false,
  pricing = false,
  signup = false,
  hasColor = false,
  ...rest
}: KitCardBodyProps) {
  return (
    <Container
      className={className}
      {...rest}
      background={background}
      plain={plain}
      formHorizontal={formHorizontal}
      pricing={pricing}
      signup={signup}
      hasColor={hasColor}
    >
      {children}
    </Container>
  );
}

const Container = styled('div', {
  shouldForwardProp: (prop) =>
    ![
      'background',
      'plain',
      'formHorizontal',
      'pricing',
      'signup',
      'hasColor',
    ].includes(prop as string),
})<KitCardBodyStyleProps>(
  ({
    theme
  }) => ({
    padding: '0.9375rem 1.875rem',
    flex: '1 1 auto',
    WebkitBoxFlex: '1',
    variants: [{
      props: (
        {
          background
        }
      ) => background,
      style: {
        position: 'relative',
        zIndex: '2',
        minHeight: '280px',
        paddingTop: '40px',
        paddingBottom: '40px',
        maxWidth: '440px',
        margin: '0 auto',
      }
    }, {
      props: (
        {
          plain
        }
      ) => plain,
      style: { paddingLeft: '5px', paddingRight: '5px' }
    }, {
      props: (
        {
          formHorizontal
        }
      ) => formHorizontal,
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        '& form': {
          margin: '0',
        }
      }
    }, {
      props: (
        {
          formHorizontal,
          pricing
        }
      ) => formHorizontal && pricing,
      style: {
        padding: '15px!important',
        margin: '0px!important',
      }
    }, {
      props: (
        {
          formHorizontal,
          signup
        }
      ) => formHorizontal && signup,
      style: {
        padding: '0px 30px 0px 30px',
      }
    }, {
      props: (
        {
          hasColor
        }
      ) => hasColor,
      style: {
        borderRadius: '6px',
        '& h1,& h2,& h3': {
          '& small': {
            color: 'rgba(' + hexToRgb(theme.palette.common.white) + ', 0.8)',
          },
        },
      }
    }]
  }),
);
